module.exports = __webpack_public_path__ + "media/images/emblems/St._Silvester-coat_of_arms-23bc9ef64685f1d302e3a8121bbf8314.svg";